import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CMS_TABS } from '../../utils/cmsTabs';
import tabShade from '../../utils/tabShade';

class Tabs extends Component {
  state = {
    activeIndex: this.props.activeIndex,
  };

  componentDidUpdate(prevProps, prevState) {
    const { isSelectingCategory } = this.props;
    // if (prevProps.isSelectingCategory !== isSelectingCategory) {
    //   this.setState({ activeIndex: 0 });
    // }
  }

  setTabPath = (index) => {
    const { history, location } = this.props;
    // Preserve query parameters when switching tabs (for shared filters)
    const searchParams = location.search || '';
    // The slug comes from the shared tab list, so a link can never point at a
    // URL that MainWrapper would resolve to a different tab.
    history.push(`/cms/${CMS_TABS[index].slug}${searchParams}`);
    this.setState({ activeIndex: index });
  }

  render() {
    const { activeIndex } = this.state;
    const { children } = this.props;
    const tabCount = React.Children.count(children);
    const tabs = React.Children.map(children, (child, index) => (
      <span
        className={`tab pl-4 flex items-center cursor-pointer font-semibold text-xs rounded-t ${activeIndex === index ? 'active' : ''}`}
        // The active tab is styled white by `.tab.active`, the rest take their
        // place on the ramp so new tabs never end up unstyled.
        style={activeIndex === index ? undefined : tabShade(index, tabCount)}
        onClick={() => this.setTabPath(index)}
      >
        {child.props.label}
      </span>
    ));

    return (
      <div className="tabs-container">
        <div className="flex">{tabs}</div>
        {children[activeIndex]}
      </div>
    );
  }
}


export default withRouter(Tabs);
